import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCanManageAccount } from '../hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'Administrator' | 'Collaborator' | 'user';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole = 'Administrator' 
}) => {
  const { canManageAccount } = useCanManageAccount();
  
  // For now, this component is specifically for admin access to billing
  // If user doesn't have account management permission, redirect to home
  if (!canManageAccount) {
    return <Navigate to="/" replace />;
  }

  // If user has the required permission, render the children
  return <>{children}</>;
};

export default ProtectedRoute;
